import Main from '@/views/administracion/licitaciones/configuracion/Main.vue';
import MainFirmas from '@/views/administracion/licitaciones/configuracion/firmas/Main.vue';
import MainPlantillas from '@/views/administracion/licitaciones/configuracion/plantillas/Main.vue';
import MainEtiquetas from '@/views/administracion/licitaciones/configuracion/etiquetas/Main.vue';

const auth = ['Licitaciones:ver'];
const scopes = ['Licitaciones:crear', 'Licitaciones:editar', 'Licitaciones:eliminar'];

const configuracion = [
  {
    path: 'configuracion',
    meta: {
      title: 'Configuración',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'licitacionesConfiguracionFirmas',
        path: '/',
        meta: {
          title: 'Firmas',
          auth,
          scopes,
        },
        component: MainFirmas,
        children: [],
      },
      {
        name: 'licitacionesConfiguracionPlantillas',
        path: 'plantillas',
        meta: {
          title: 'Plantillas',
          auth,
          scopes,
        },
        component: MainPlantillas,
        children: [],
      },
      {
        name: 'licitacionesConfiguracionEtiquetas',
        path: 'etiquetas',
        meta: {
          title: 'Etiquetas',
          auth,
          scopes,
        },
        component: MainEtiquetas,
        children: [],
      },
    ],
  },
];

export default configuracion;
